import { gradeOf } from '@sourcr/shared';

function gradeVar(score: number): string {
  if (score >= 60) return score >= 80 ? 'var(--grade-a)' : 'var(--grade-b)';
  return 'var(--grade-c)';
}

interface GradeChipProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
}

export function GradeChip({ score, size = 'md' }: GradeChipProps) {
  const letter = gradeOf(score);
  const color = gradeVar(score);
  const dim = size === 'sm' ? 36 : size === 'lg' ? 64 : 44;
  const letterSize = size === 'sm' ? 13 : size === 'lg' ? 26 : 16;
  const pctSize = size === 'sm' ? 8 : size === 'lg' ? 10 : 9;
  const radius = size === 'sm' ? 8 : size === 'lg' ? 14 : 10;

  return (
    <span
      title={`Score: ${score}`}
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: dim,
        height: dim,
        borderRadius: radius,
        background: `color-mix(in oklch, ${color} 18%, var(--bg-elevated))`,
        border: `1px solid color-mix(in oklch, ${color} 30%, var(--border))`,
        color,
        fontFamily: 'var(--font-mono)',
        fontWeight: 600,
        flexShrink: 0,
        gap: 1,
      }}
    >
      <span style={{ fontSize: letterSize, lineHeight: 1, letterSpacing: '-0.02em' }}>{letter}</span>
      <span style={{ fontSize: pctSize, lineHeight: 1, opacity: 0.7 }}>{score}%</span>
    </span>
  );
}

export function ScoreBar({ score }: { score: number }) {
  const color = gradeVar(score);
  return (
    <div
      style={{
        height: 4,
        borderRadius: 2,
        backgroundColor: 'var(--bg-overlay)',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <div
        style={{
          height: '100%',
          width: `${score}%`,
          backgroundColor: color,
          borderRadius: 2,
          transition: 'width 0.4s ease',
        }}
      />
    </div>
  );
}
